import EntityAudits from "@/components/EntityAudits.vue";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityLocations } from "@modernary/mui/components/location";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

const names = {
  facilities: "Facility.Facility",
  list: "Facility.Facilities",
  new: "Facility.FacilityNew",
  base: "Facility.FacilityBase",
  view: "Facility.FacilityView,",
  notes: "Facility.FacilityNotes",
  noteEdit: "Facility.FacilityNoteEdit",
  noteNew: "Facility.FacilityNoteNew",
  locations: "Facility.FacilityLocations",
  edit: "Facility.FacilityEdit",
  editStatus: "Facility.FacilityEditStatus",
  editPriority: "Facility.FacilityEditPriority",
  documents: "Facility.FacilityDocuments",
  documentEdit: "Facility.FacilityDocumentEdit",
  documentNew: "Facility.FacilityDocumentNew",
  audit: "Facility.FacilityAudit",
};

export { names as FacilityRouteNames };

const FacilityRoutes: RouterOptions["routes"] = [
  {
    path: "/facilities",
    name: names.facilities,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "HEPCRA Facilities",
        },
        component: () => import("@/views/facility/FacilityList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/facility/FacilityBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "HEPCRA Facility New", isNew: true },
            component: () => import("@/views/facility/FacilityEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/facility/FacilityBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "HEPCRA Facility View" },
            component: () => import("@/views/facility/FacilityView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "HEPCRA Facility Edit", isForm: true },
            component: () => import("@/views/facility/FacilityEdit.vue"),
          },
          {
            path: "editStatus",
            name: names.editStatus,
            meta: { title: "HEPCRA Facility Status Edit", isForm: true },
            component: () => import("@/views/facility/FacilityStatusEdit.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "HEPCRA Facility Notes" },
            component: {
              render: () => <EntityNotes idField="facilityId" routeNamePrefix="Facility.FacilityNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "HEPCRA Facility Note Edit", isForm: true },
            component: () => import("@/views/facility/FacilityNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "HEPCRA Facility Note New", isForm: true },
            component: () => import("@/views/facility/FacilityNote.vue"),
          },
          {
            path: "locations",
            name: names.locations,
            meta: { title: "HEPCRA Facility Locations" },
            component: {
              render: () => <EntityLocations murnResourceType="facility" />,
            },
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "HEPCRA Facility Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="facility" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "HEPCRA Facility Document Edit", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="facility" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "HEPCRA Facility Document New", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="facility" />,
            },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "HEPCRA Facility Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Facility" />,
            },
          },
        ],
      },
    ],
  },
];
export default FacilityRoutes;
